import React, { Component } from 'react';
import Fecha from 'fecha';

import { Row, Col, Collapse } from 'react-bootstrap'

const marginRemove = {
	marginLeft: "0px",
	marginRight: "0px"
}

const titleStyle = {
	backgroundColor: "#004d99",
	color: "#fff",
	fontWeight: "bold",
	marginLeft: "0px",
	marginRight: "0px"
}

const padding = {
	padding: "15px",
	wordWrap: "break-word"
}


const leftClass = "col-lg-3 col-sm-3 col-4 border";
const rightClass = "col-lg-9 col-sm-9 col-8 border";
const sIdClass = "col-lg-1 col-sm-1 col-2 d-flex justify-content-center align-self-center";

export default class TrustedLists extends Component {

	constructor(props) {
		super(props);
		this.state = {
			open: false,
		};
	}

	render() {
		return (
			<React.Fragment>

				<Row tabIndex="0" role="button" style={titleStyle} className="border-top" onClick={() => this.setState({ open: !this.state.open })} onKeyUp={this.props.handleKeyUp}>
					<Col style={padding} className="col-lg-12 col-sm-12 col-12">
						<Row style={marginRemove}>
							<Col className="col-lg-11 col-sm-11 col-10">
								<Row>
									<Col style={{ "paddingLeft": "5px" }} className="col-3">
										Country Code:
									</Col>
									<Col className="col-9">
										{this.props.data.countryCode}
									</Col>
								</Row>
							</Col>
							<Col className={sIdClass} style={{ "paddingRight": "0px" }}>
								{this.state.open ?
									<i className="material-icons align-middle" aria-hidden="true">expand_less</i>
									:
									<i className="material-icons align-middle" aria-hidden="true">expand_more</i>
								}
							</Col>
						</Row>
					</Col>
				</Row>

				<Collapse in={this.state.open}>
					<div>
						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>URL:</Col>
							<Col style={padding} className={rightClass}>{dataValue(this.props.data.url)}</Col>
						</Row>
						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>Sequence Number:</Col>
							<Col style={padding} className={rightClass}>{dataValue(this.props.data.sequenceNumber)}</Col>
						</Row>
						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>Version:</Col>
							<Col style={padding} className={rightClass}>{dataValue(this.props.data.version)}</Col>
						</Row>
						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>Last Loading:</Col>
							<Col style={padding} className={rightClass}>
								{this.props.data.lastLoading == null ?
									"-"
									:
									Fecha.format(new Date(this.props.data.lastLoading), 'DD.MM.YYYY. [at] HH:mm')
								}
							</Col>
						</Row>
						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>Issued Date:</Col>
							<Col style={padding} className={rightClass}>
								{this.props.data.issueDate == null ?
									"-"
									:
									Fecha.format(new Date(this.props.data.issueDate), 'DD.MM.YYYY. [at] HH:mm')
								}
							</Col>
						</Row>
						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>Next Update:</Col>
							<Col style={padding} className={rightClass}>
								{this.props.data.nextUpdate == null ?
									"-"
									:
									Fecha.format(new Date(this.props.data.nextUpdate), 'DD.MM.YYYY. [at] HH:mm')
								}
							</Col>
						</Row>
						<Row style={marginRemove}>
							<Col style={padding} className={leftClass}>Well Signed:</Col>
							<Col style={padding} className={rightClass}>{dataValue(this.props.data.wellSigned)}</Col>
						</Row>

					</div>
				</Collapse>
			</React.Fragment >
		);
	}
}

function dataValue(value) {
	return <React.Fragment>
		{value == null ?
			"-"
			:
			<React.Fragment>{'' + value}</React.Fragment>
		}
	</React.Fragment>
}